import React, { useState } from 'react';
import AddEventModal from '../components/AddEventModal';

const AddEventPage = () => {
  const [showModal, setShowModal] = useState(true);

  return showModal ? (
    <AddEventModal
      onClose={() => setShowModal(false)}
      onAdd={(e) => console.log('New event:', e)}
    />
  ) : (
    <p className="text-center mt-8 text-white">Event modal closed.</p>
  );
};

export default AddEventPage;
